import React from 'react'
import { PulseLoader } from 'halogen'

const styles = {
  spinner: {
    display: 'flex',
    height: '80vh',
    justifyContent: 'center',
    alignItems: 'center',
    alignContent: 'center'
  }
}

const Spinner = () => (
  <div style={styles.spinner}>
    <PulseLoader color={'#00abde'} />
  </div>
)

export default Spinner



// WEBPACK FOOTER //
// ./src/components/common/Spinner/Spinner.js